import React from 'react';
import {FaIcon} from "../FaIcon";
import {EditElementModal} from "../EditElementModal";
import {EditPeriodDatesForm} from "./EditPeriodDatesForm";
import { withTranslation } from 'react-i18next';

class EditPeriodDatesModalComponent extends EditElementModal {
    renderModalForm() {
        return <EditPeriodDatesForm closeModal={this.toggle}
                                    onModified={this.handleFormSubmitted}
                                    clientName={this.props.clientName}
                                    businessUnitId={this.props.businessUnitId}
                                    businessUnitName={this.props.businessUnitName}
                                    campaignsConfigurationId={this.props.campaignsConfigurationId}
                                    campaignId={this.props.campaignId}
                                    adgroupId={this.props.adgroupId}
                                    itemPeriodDates={this.props.itemPeriodDates}

        />
    }

    renderButton() {
        return <button className="edit-button" onClick={this.toggle}><FaIcon iconName={"pencil-alt"}/></button>;
    }

    renderModalHeaderText() {
        const { t } = this.props;
        return t('modal.edit_control_line_dates');
    }
}

export const EditPeriodDatesModal = withTranslation()(EditPeriodDatesModalComponent);
